<template>
  <div id="YourCoach">
    <b-modal
      v-if="bannerData"
      id="good-morning-modal"
      size="lg"
      v-bind:modal-class="'good-morning-modal ' + getTheme()"
      @hidden="setBanner"
      hide-footer
      hide-header
    >
      <div class="title">Hello<span v-if="userName" class="blue-text"> {{userName}}</span>, how can we help today?</div>
      <div class="navigation-cards">
        <NavigationCard
          v-for="item in bannerData.items"
          :key="item.id"
          :description='item.description'
          :icon="item.icon"
          :link="item.url"
        />
      </div>
      <div class="checkbox-container">
        <input
          type="checkbox"
          id="agree-checkbox"
          v-model="doNotShowAgain"
          aria-label="Agree to privacy policy"
          class="checkbox"
        />
        <label for="agree-checkbox" class="checkbox-text">
          Don't show this window again.
        </label>
      </div>
      <b-button
        @click="closeModal"
        class="button">
        Take me to the homepage
      </b-button>
    </b-modal>
  
  </div>

</template>

<script>
import NavigationCard from "@/components/Home/New/NavigationCard.vue";
import axios from "axios";
import config from "../../../config/constants";

export default {
  components: {
    NavigationCard
  },
  name: "HomeStartModal",
  data() {
    return {
      doNotShowAgain: false,
      bannerData: null
    };
  },
  computed: {
    userName() {
      return this.$store.getters.user.user.first_name || null;
    }
  },
  async mounted() {
    await this.getGoodMorningBanner()
    this.$bvModal.show("good-morning-modal");
  },
  methods: {
    async getGoodMorningBanner() {
      const payload = {
          user_id: this.$store.getters.user_id,
        }
      const res = await axios.post(config.api_env + '/application/api/u/marketplace/get-good-morning-banner', payload, config.options)
      if (res.data.success && res.data.banner) {
        this.bannerData = res.data.banner
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
      }
    },
    closeModal() {
      this.$bvModal.hide("good-morning-modal")
    },
    async setBanner() {
      const payload = {
          user_id: this.$store.getters.user_id,
          banner_name: "good_morning",
          set_show: !this.doNotShowAgain
      }
      const res = await axios.post(config.api_env + '/application/api/u/user/set-banner', payload, config.options)
      if(res.data.success) {
        localStorage.setItem("goodMorningBanner", !this.doNotShowAgain);
      }
    }
  }
};
</script>
<style lang="less">

#good-morning-modal {

  .modal-body {
    padding: 40px;
    display: flex;
    flex-direction: column;
  }

  .modal-content {
    border-radius: 0;
    overflow: auto;
    max-height: 90vh;
    max-width: 90vh;
  }
  
  .title {
    font-size: 32px;
    text-align: center;
    line-height: 36px;
    font-weight: bolder;
    font-family: "Raptor V3 Black";
    margin-bottom: 40px;
  }
  
  .blue-text {
    color: #604AFF;
  }
  
  .navigation-cards {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 27px;
    margin-bottom: 40px;
    max-height: 50vh;
    overflow-y: scroll;
  }
  
  .checkbox-container {
    display: flex;
    justify-content: flex-start;
    gap: 14px;
    margin: 0 0 32px 40px;
  }
  
  .checkbox {
    cursor: pointer;
    width: 28px;
    height: 28px;
    font-family: "DMSans";

    &:before {
      content: "";
      display: block;
      width: 28px;
      background-color: #fff;
      border: 3px solid #604AFF;
      height: 28px;
    }

    &:checked:before {
      content: "✔";
      font-size: 2rem;
      line-height: 2rem;
      padding: 2px;
      color: #fff;
      background-color: #604AFF;
    }
  }
  
  .checkbox-text {
    font-size: 18px;
    cursor: pointer;
    margin: 0;
  }

  .button {
    background-color: #604AFF;
    align-self: center;
    border-radius: 5px;
    padding: 12px 20px;
    color: #ffffff;
    font-size: 16px;
    border: none;
    margin-bottom: 40px;
    font-family: "Raptor V3 Black";
  }
}
</style>
